import api from ".";
import cookiesModifier from "../utils/cookies";
import { IFlatNotification, INotification } from "../types/notification";

export const getAllNotification = async () => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.get(`notifications`);
        return res.data as INotification[];
    } catch (error) {
        throw error;
    }
}

export const createNotification = async (data: IFlatNotification) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    const { senderType, ...record } = data;
    try {
        const res = await api.post(`notifications/${senderType}`, record);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const updateNotification = async (data: IFlatNotification) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    const { senderType, ...record } = data;
    try {
        const res = await api.patch(`notifications/${record.id}`, record);
        return res.status;
    } catch (error) {
        throw error;
    }
}


export const deleteNotification = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`notifications/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}


export const sendNotification = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post(`notifications/send/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}